var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViezdnie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7766_53981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 -0.000230428L13 24.9998L8.66142 16.6563L0 12.4998C0 12.4998 25.9738 -0.0153636 26 -0.000230428Z",
    fill: "#9E071E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5L11.699 13.751L13 25L8.66142 16.6566L0 12.5Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 0L11.699 13.751L0 12.5L26 0Z",
    fill: "#E34A4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7766_53981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViezdnie);
export default __webpack_public_path__ + "static/media/viezdnie.7fdec664662239f0d7c92af5ba7e3644.svg";
export { ForwardRef as ReactComponent };